<template>
    <div class="mb-5 periods" style="margin-bottom: 50px !important;">
        <div v-for="field in privateFields">
            <label :style="'color:' + fieldsColor">
                {{ formatDescTitle(field.fieldable.code) }}
                <img :src="'/images/flags/' + getLanguageFromCode(field.fieldable.code) + '.png'" height="20px">
                <help-tooltip :content="getField(field.fieldable.code).helpDescription"></help-tooltip>
            </label>
            <v-textarea
              class="textarea mb-5"
              :value="getPrivateDescValue(field.fieldable.code)"
              @change="updateDescValue($event, field.fieldable.code)"
              outlined>
            </v-textarea>
        </div>
    </div>
</template>

<script>
import Confirm from "../../../tools/Confirm"
import { mapGetters, mapMutations, mapState } from "vuex"
import HelpTooltip from "../../../tools/HelpTooltip.vue";

export default {
    name: "PrivateDescriptifs",
    components: {HelpTooltip},
    data() {
        return {
            privateFields: []
        }
    },
    methods: {
        formatDescTitle(title) {
            return this.getField(title).name.replace(/ *\([^)]*\) */g, "")
        },
        getPrivateDescValue(code) {
            let value = null
            let lg = this.getLanguageFromCode(code)

            let description = this.provider.private_descriptions.find(privateDescription => {
                return privateDescription.code === code.slice(0, -3) && privateDescription.language.code === lg
            })

            if (description) {
                value = description.description
            }

            return value
        },
        updateDescValue(value, code) {
            let lg = this.getLanguageFromCode(code)

            let description = this.provider.private_descriptions.find(privateDescription => {
                return privateDescription.code === code.slice(0, -3) && privateDescription.language.code === lg
            })

            if (description === undefined) {
                let language = this.languages.find(lang => lang.code === lg)

                this.provider.private_descriptions.push({
                    code: code.slice(0, -3),
                    description: value,
                    language: language
                })
            } else {
                description.description = value
            }
        },
        getLanguageFromCode(code) {
            return code.slice(-2)
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'disabled', 'suggestedOpeningDays', 'suggestedH24', 'fields']),
        ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode',
            'getField']),
        ...mapState('resource', ['languages']),
    },
    created() {
        this.fields.forEach(field => {
            if (field.fieldable.family !== undefined &&
              field.fieldable.family !== null &&
              field.fieldable.family.label === "Descriptifs privés")
            {
                this.privateFields.push(field)
            }
        })

        this.privateFields = this.privateFields.sort((a, b) => {
            return b.name - a.name
        })
    }
}
</script>
